import React from 'react';
import StandardTools from './StandardTools';
import ToolsMenu from './ToolsMenu';

const StandardToolsMenu = ({
  allowDelete,
  allowRead,
  asHref,
  children,
  deleteIcon = 'trash alternate',
  deleteMessage = 'actions.delete',
  deleteWarningMessage,
  href,
  icon = 'ellipsis vertical',
  listItem = false,
  onChange,
  onDelete,
  open,
  pointing = 'right',
  upward,
}) => (
  <ToolsMenu
    icon={icon}
    listItem={listItem}
    onChange={onChange}
    pointing={pointing}
    upward={upward}
  >
    {(open || !onChange) && (
    <StandardTools
      onDelete={onDelete}
      allowDelete={allowDelete}
      allowRead={allowRead}
      href={href}
      asHref={asHref}
      deleteIcon={deleteIcon}
      deleteMessage={deleteMessage}
      deleteWarningMessage={deleteWarningMessage}
    >
      {children}
    </StandardTools>
    )}
  </ToolsMenu>
);

export default StandardToolsMenu;
